import { ExtendedAttributeFilterInterface } from 'app/library/all-users/interfaces/extended-attribute-filer.interface';
import { ICreateEntityFailureActionPayload } from 'app/projects/entity/src/lib/interfaces/create-entity-failure-payload.interface';
import { IFetchEntityFailureActionPayload } from 'app/projects/entity/src/lib/interfaces/fetch-entity-failure-payload.interface';
import { IUpdateEntityFailureActionPayload } from 'app/projects/entity/src/lib/interfaces/update-entity-failure-payload.interface';
import { CourseStructureCategoryTree } from '../models/course-structure-category-tree.model';
import { CourseStructureCategory } from '../models/course-structure-category.model';
import { CourseStructureSubcategory } from '../models/course-structure-subcategory.model';
import { ICourseStructureSubCategoryActionPayload } from '../interfaces/course-structure-subcategory.action-payload.interface';

export class SetCourseStructureCategory {
    static readonly type = '[CourseOfferingsCategory] SetCourseStructureCategory';

    constructor(public payload: CourseStructureCategory) {}
}

export class UnsetCourseStructureCategory {
    static readonly type = '[CourseOfferingsCategory] UnsetCourseStructureCategory';
}

export class FetchCourseStructureCategory {
    static readonly type = '[CourseOfferingsCategory] FetchCourseStructureCategory';

    constructor(public payload: string) {}
}

export class FetchCourseStructureCategorySuccess {
    static readonly type = '[CourseOfferingsCategory] FetchCourseStructureCategorySuccess';

    constructor(public payload: CourseStructureCategory) {}
}

export class FetchCourseStructureCategoryFailure {
    static readonly type = '[CourseOfferingsCategory] FetchCourseStructureCategoryFailure';

    constructor(public payload: IFetchEntityFailureActionPayload) {}
}

export class CreateCourseStructureCategory {
    static readonly type = '[CourseOfferingsCategory] CreateCourseStructureCategory';

    constructor(public payload: CourseStructureCategory) {}
}

export class CreateCourseStructureCategorySuccess {
    static readonly type = '[CourseOfferingsCategory] CreateCourseStructureCategorySuccess';

    constructor(public payload: CourseStructureCategory) {}
}

export class CreateCourseStructureCategoryFailure {
    static readonly type = '[CourseOfferingsCategory] CreateCourseStructureCategoryFailure';

    constructor(public payload: ICreateEntityFailureActionPayload) {}
}

export class UpdateCourseStructureCategory {
    static readonly type = '[CourseOfferingsCategory] UpdateCourseStructureCategory';

    constructor(public payload: CourseStructureCategory) {}
}

export class UpdateCourseStructureCategorySuccess {
    static readonly type = '[CourseOfferingsCategory] UpdateCourseStructureCategorySuccess';

    constructor(public payload: CourseStructureCategory) {}
}

export class UpdateCourseStructureCategoryFailure {
    static readonly type = '[CourseOfferingsCategory] UpdateCourseStructureCategoryFailure';

    constructor(public payload: IUpdateEntityFailureActionPayload) {}
}
export class DeleteCourseStructureCategory {
    static readonly type = '[CourseOfferingsCategory] DeleteCourseStructureCategory';

    constructor(public payload: string) {}
}

export class DeleteCourseStructureCategorySuccess {
    static readonly type = '[CourseOfferingsCategory] DeleteCourseStructureCategorySuccess';

    constructor(public payload: string) {}
}

export class DeleteCourseStructureCategoryFailure {
    static readonly type = '[CourseOfferingsCategory] DeleteCourseStructureCategoryFailure';

    constructor(public payload: string) {}
}

export class SetCourseStructureCategories {
    static readonly type = '[CourseOfferingsCategory] SetCourseStructureCategories';

    constructor(public payload: CourseStructureCategory[]) {}
}

export class FetchCourseStructureCategories {
    static readonly type = '[CourseOfferingsCategory] FetchCourseStructureCategories';
}

export class FetchCourseStructureCategoriesSuccess {
    static readonly type = '[CourseOfferingsCategory] FetchCourseStructureCategoriesSuccess';
}

export class FetchCourseStructureCategoriesFailure {
    static readonly type = '[CourseOfferingsCategory] FetchCourseStructureCategoriesFailure';
}

export class ToggleSelectedCourseStructureCategory {
    static readonly type = '[CourseOfferingsCategory] ToggleSelectedCourseStructureCategory';

    constructor(public payload: string) {}
}

export class SelectFilteredCourseStructureCategories {
    static readonly type = '[CourseOfferingsCategory] SelectFilteredCourseStructureCategories';
}

export class DeselectSelectedCourseStructureCategories {
    static readonly type = '[CourseOfferingsCategory] DeselectSelectedCourseStructureCategories';
}

export class FetchCourseStructureCategoriesTree {
    static readonly type = '[CourseOfferingsCategory] FetchCourseStructureCategoriesTree';

    constructor(public payload: { courseOfferingType: number }) {}
}

export class FetchCourseStructureCategoriesTreeSuccess {
    static readonly type = '[CourseOfferingsCategory] FetchCourseStructureCategoriesTreeSuccess';

    constructor(public payload: CourseStructureCategoryTree[]) {}
}

export class FetchCourseStructureCategoriesTreeFailure {
    static readonly type = '[CourseOfferingsCategory] FetchCourseStructureCategoriesTreeFailure';
}

export class SearchCourseStructureCategories {
    static readonly type = '[CourseOfferingsCategory] SearchCourseStructureCategories';

    constructor(
        public payload: {
            searchTerm: string;
            fetchCourseStructureCategoriesDataAsTree: boolean;
            courseOfferingType: number;
            tags: string[];
            types: string[];
            extendedAttributesFilters: ExtendedAttributeFilterInterface[];
            columns: string[];
        }
    ) {}
}

export class SearchCourseStructureCategoriesSuccess {
    static readonly type = '[CourseOfferingsCategory] SearchCourseStructureCategoriesSuccess';

    constructor(public payload: CourseStructureCategoryTree[]) {}
}

export class SearchCourseStructureCategoriesFailure {
    static readonly type = '[CourseOfferingsCategory] SearchCourseStructureCategoriesFailure';
}

export class MoveCourseStructureCategory {
    static readonly type = '[CourseOfferingsCategory] MoveCourseStructureCategory';

    constructor(
        public payload: {
            categoryId: string;
            parentId: string;
        }
    ) {}
}

export class MoveCourseStructureCategorySuccess {
    static readonly type = '[CourseOfferingsCategory] MoveCourseStructureCategorySuccess';

    constructor(public payload: CourseStructureCategory) {}
}

export class MoveCourseStructureCategoryFailure {
    static readonly type = '[CourseOfferingsCategory] MoveCourseStructureCategoryFailure';

    constructor(public payload: IUpdateEntityFailureActionPayload) {}
}

export class FetchCourseStructureCategorySubcategories {
    static readonly type = '[CourseOfferingsCategory] FetchCourseStructureCategorySubcategories';

    constructor(public payload: string) {}
}

export class FetchCourseStructureCategorySubcategoriesSuccess {
    static readonly type = '[CourseOfferingsCategory] FetchCourseStructureCategorySubcategoriesSuccess';

    constructor(public payload: CourseStructureSubcategory[]) {}
}

export class FetchCourseStructureCategorySubcategoriesFailure {
    static readonly type = '[CourseOfferingsCategory] FetchCourseStructureCategorySubcategoriesFailure';
}

export class CreateCourseStructureSubCategory {
    static readonly type = '[CourseOfferingsCategory] CreateCourseStructureSubCategory';

    constructor(public payload: ICourseStructureSubCategoryActionPayload) {}
}

export class CreateCourseStructureSubCategorySuccess {
    static readonly type = '[CourseOfferingsCategory] CreateCourseStructureSubCategorySuccess';

    constructor(public payload: CourseStructureSubcategory) {}
}

export class CreateCourseStructureSubCategoryFailure {
    static readonly type = '[CourseOfferingsCategory] CreateCourseStructureSubCategoryFailure';

    constructor(public payload: ICreateEntityFailureActionPayload) {}
}

export class UpdateCourseStructureCategoryOrder {
    static readonly type = '[CourseOfferingsCategory] UpdateCourseStructureCategoryOrder';

    constructor(public payload: CourseStructureCategory) {}
}

export class UpdateCourseStructureCategoryOrderSuccess {
    static readonly type = '[CourseOfferingsCategory] UpdateCourseStructureCategoryOrderSuccess';

    constructor(public payload: CourseStructureCategory) {}
}

export class UpdateCourseStructureCategoryOrderFailure {
    static readonly type = '[CourseOfferingsCategory] UpdateCourseStructureCategoryOrderFailure';

    constructor(public payload: IUpdateEntityFailureActionPayload) {}
}
